<a [href]="url" target="_blank" class="btn btn--secondary" title="Geef uw mening" rel="nofollow noopener">
    Geef uw mening
</a>
